var sizes = {
  container: {
    1: "77px",
    2: "174px",
    3: "271px",
    4: "368px",
    5: "465px",
    6: "562px",
    7: "659px",
    8: "756px",
    9: "853px",
    10: "950px",
    11: "1047px",
    12: "1144px"
  }
};
export { sizes as default };